export function InspectionNewPage() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold">New Inspection</h1>
      <p className="text-muted-foreground">
        Use the "New Inspection" button on the Inspections page to launch an inspection from a
        template.
      </p>
    </div>
  );
}
